import type { QueryClient } from "@tanstack/react-query";
import type { createApi } from "../../core/api/api-utils";
import type { PatientId } from "../../shared/schema/schema";

export async function loadPatientVisitPrefill(
  queryClient: QueryClient,
  api: Pick<ReturnType<typeof createApi>, "get">,
  patientId: PatientId
) {
  // Share both completed and in-flight reads with the patient window. Explicit
  // invalidation (e.g. editing an authorization) still causes a fresh request.
  const [authorizations, staffingPreferences] = await Promise.all([
    queryClient.fetchQuery({
      queryKey: ["patientProfileModal", patientId, "authorizations"],
      queryFn: () => api.get("./authorizations/:patientId", { path: { patientId } }),
      staleTime: Infinity,
    }),
    queryClient.fetchQuery({
      queryKey: ["patientProfileModal", patientId, "staffingPreferences"],
      queryFn: () => api.get("./patients/:patientId/staffing_preferences", { path: { patientId } }),
      staleTime: Infinity,
    }),
  ]);
  return {
    // Angular's date handling expects the wire format, not revived LocalDate
    // objects. Copy so the modal's formatting cannot mutate React Query data.
    patientAuthorizations: JSON.parse(JSON.stringify(authorizations.authorizations)),
    patientStaffingPreferences: staffingPreferences,
  };
}
